import { compose } from 'redux'
import { connect } from 'react-redux'
import { reduxForm, } from 'redux-form';
import { listar } from '../../actions'


const mapStateToProps = ({ OkReportReducer }, props) => {
    const { loading, lista } = OkReportReducer.rLista;
    let listaFinal = [];
    if (lista) {
        listaFinal = lista.slice()
    }

    return { loadingListaPesquisa: loading, listaPesquisa: listaFinal };
};


export default compose(
    connect(mapStateToProps, { listar }),
    reduxForm({
        form: 'OkReportDeveloperPesquisa',
    })
);





// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/OkReportDeveloperPesquisa/OkReportDeveloperPesquisa.enhancer.js